import { useNavigate, useParams } from "react-router-dom";
import useUserContext from "../../hooks/useUserContext";
import AutomationTreeEditor from "./AutomationTreeEditor";
import { Button, Space } from "antd";

export default function AutomationTreeEditorPage() {
    const navigate = useNavigate();
    const { automationId } = useParams();
    const { selectedDomain } = useUserContext();
    const id = Number(automationId);

    if (!selectedDomain || !Number.isFinite(id) || id <= 0) return null;

    return (
        <div>
            <Space style={{ marginBottom: 12 }}>
                <Button onClick={() => navigate(`/automations-pro`)}>Back</Button>
            </Space>
            <AutomationTreeEditor domain={selectedDomain} automationId={id} />
        </div>
    );
}
